// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2WS4f","list":"styles_list__2bi0k"};